import {GET_ALL_PAYROLL_ALLOWANCE} from "../../constant/ActionType";

export default function AllowancePayrollDomain(state = {
    AllowancePayAll:[],
    statusCode: null,
}, action) {
    switch (action.type) {    
        case GET_ALL_PAYROLL_ALLOWANCE:
			return { ...state,
				AllowancePayAll: action?.data ,
                statusCode:action.status
            };

        default:
    }
    return state;
}








